/* Afspiller produktvideoen når musen føres hen over den.
   Temaet starter den ellers først når man klikker sig hen på billedet.
   Lyden er slået fra, ellers blokerer browseren automatisk afspilning. */
(function () {
  function bind() {
    var afspillere = document.querySelectorAll('video-player');
    if (!afspillere.length) return false;
    afspillere.forEach(function (vp) {
      if (vp.dataset.hoverBundet) return;
      vp.dataset.hoverBundet = '1';

      vp.addEventListener('mouseenter', function () {
        try {
          if (typeof vp.loadContent === 'function') vp.loadContent();
          if (typeof vp.play === 'function') {
            var pp = vp.play();
            if (pp && pp.catch) pp.catch(function () {});
          }
        } catch (e) {}
        var forsoeg = 0;
        var t = setInterval(function () {
          forsoeg++;
          var v = vp.querySelector('video');
          if (v) {
            v.muted = true;
            v.loop = true;
            v.setAttribute('playsinline', '');
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
            clearInterval(t);
          }
          if (forsoeg > 20) clearInterval(t);
        }, 200);
      });

      vp.addEventListener('mouseleave', function () {
        try {
          var v = vp.querySelector('video');
          if (v && typeof v.pause === 'function') v.pause();
          else if (typeof vp.pause === 'function') vp.pause();
        } catch (e) {}
      });
    });
    return true;
  }
  var n = 0;
  (function proev() { n++; if (!bind() && n < 40) setTimeout(proev, 300); })();
  document.addEventListener('shopify:section:load', bind);
})();
